import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const USER_SCROLL = ["wheel", "touchstart", "keydown"];

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    // Re-correct after images/animations shift layout, but stop as soon as the user scrolls
    const go = () => document.querySelector(hash)?.scrollIntoView({ behavior: "instant" });
    const timers = [80, 500, 1100].map((ms) => setTimeout(go, ms));
    const stop = () => timers.forEach(clearTimeout);
    USER_SCROLL.forEach((e) => window.addEventListener(e, stop, { passive: true, once: true }));
    return () => {
      stop();
      USER_SCROLL.forEach((e) => window.removeEventListener(e, stop));
    };
  }, [pathname, hash]);
  return null;
}
